<template>
  <div>
    <div class="contract">
      <Header
        v-if="!checkCreatedDateNganluong(dataAppendix)"
        :groupService="dataContract.groupService"
      ></Header>
      <HeaderNL v-else :groupService="dataContract.groupService"></HeaderNL>
      <p class="txt-center fonsize-16 txt-tranf">CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</p>
      <p class="txt-center fonsize-16">Độc lập – Tự do – Hạnh phúc</p>
      <p class="txt-center fonsize-16">***</p>
      <p class="txt-tranf txt-center fonsize-20 magb20">
        <b
          >PHỤ LỤC<br />
          CUNG CẤP VÀ BÀN GIAO THIẾT BỊ THANH TOÁN THẺ
        </b>
      </p>
      <p class="txt-center">
        (PLHTTB:
        <mark>{{ codeAppendixLend }}</mark>
        )
      </p>
      <p>Căn cứ:</p>
      <ol class="form-style2">
        <li>
          <span>
            Hợp đồng hợp tác chấp nhận thanh toán số
            <mark>{{
              dataAppendix?.isNganluongContract ? dataAppendix.codeOfContract : dataContract.code
            }}</mark>
          </span>
          <p class="magt10">
            (sau đây được viết tắt là “Hợp đồng”) ký ngày
            <mark v-if="dataAppendix?.isNganluongContract">
              {{ dataAppendix?.dateSignContract | formatDate }}</mark
            >
            <mark v-else>
              {{
                dataContract.effectiveFromDTO
                  ? dataContract.effectiveFromDTO
                  : dataContract.dateSign | formatDate
              }}</mark
            >
          </p>
        </li>
        <li>Nhu cầu và khả năng của hai Bên.</li>
      </ol>
      <p>
        Hôm nay, ngày
        <mark v-if="dataAppendix.dateSignAppendixDTO">{{
          dataAppendix.dateSignAppendixDTO | formatDate
        }}</mark>
        <mark v-else-if="dataAppendix.dateCreatedAppendixDTO">{{
          dataAppendix.dateCreatedAppendixDTO | formatDate
        }}</mark>
        <mark v-else-if="dataContract.effectiveFromDTO">{{
          dataContract.effectiveFromDTO | formatDate
        }}</mark>
        ,
        {{
          checkCreatedDateNganluong(dataAppendix)
            ? 'tại trụ sở Công ty Cổ phần cổng trung gian thanh toán Ngân Lượng, chúng tôi gồm có:'
            : 'tại trụ sở Công ty Cổ phần Công nghệ Vi Mô, chúng tôi gồm có:'
        }}
      </p>
      <p class="flex fonsize-16 txt-tranf">
        <b v-if="!checkCreatedDateNganluong(dataAppendix)"
          >BÊN A: CÔNG TY CỔ PHẦN CÔNG NGHỆ VI MÔ</b
        >
        <b v-else>BÊN A: CÔNG TY CỔ PHẦN CỔNG TRUNG GIAN THANH TOÁN NGÂN LƯỢNG</b>
      </p>
      <p v-if="checkCreatedDateNganluong(dataAppendix)">
        Trụ sở: Tầng 3, tòa nhà VTC online, số 18 đường Tam Trinh, phường Tương Mai, thành phố Hà
        Nội, Việt Nam.
      </p>
      <p v-else>
        Trụ sở: Tầng 12A, tòa nhà VTC online, số 18 đường Tam Trinh, phường Tương Mai, thành phố Hà
        Nội, Việt Nam.
      </p>
      <div class="form form-ext">
        <p>
          Điện thoại: 024 36320986
          <span class="ml-4" v-if="!checkCreatedDateNganluong(dataAppendix)"
            >Fax: 024 36320987</span
          >
        </p>
        <p v-if="!checkCreatedDateNganluong(dataAppendix)">Tài khoản: 11001010157634</p>
        <p v-if="!checkCreatedDateNganluong(dataAppendix)">Tại: Ngân hàng Maritimebank</p>
        <p v-if="checkCreatedDateNganluong(dataAppendix)">Mã số thuế: 0106001236</p>
        <p v-else>Mã số thuế: 0106393463</p>
        <p>
          Người đại diện:
          <b
            v-if="
              dataAppendix?.dateSignAppendixDTO ||
              dataAppendix?.dateCreatedAppendixDTO ||
              dataContract?.effectiveFromDTO
                ? (dataAppendix?.dateSignAppendixDTO ||
                    dataAppendix?.dateCreatedAppendixDTO ||
                    dataContract?.effectiveFromDTO) < new Date('2026-01-07').getTime()
                : new Date() < new Date('2026-01-07')
            "
            >ĐỖ CÔNG DIỄN</b
          >
          <b v-else>Ông NGUYỄN TIẾN LƯỢNG</b>
          <span class="ml-4"
            >Chức vụ: <b v-if="!checkCreatedDateNganluong(dataAppendix)">Tổng Giám Đốc</b
            ><b v-else>Phó Tổng Giám đốc kiêm Giám đốc BU Chuyển đổi số</b></span
          >
        </p>
        <p v-if="checkCreatedDateNganluong(dataAppendix)">
          Giấy ủy quyền số: 1302/2026/GUQ/NGANLUONG ngày 13/02/2026
        </p>
        <p>
          NVKD: <b>{{ dataContract.saleInfoRes.name ? dataContract.saleInfoRes.name : '' }}</b>
          <span class="ml-4">Điện thoại:</span>
          <b>{{ dataContract.saleInfoRes.mobile ? dataContract.saleInfoRes.mobile : '' }}</b>
        </p>
      </div>
      <p>và</p>
      <p class="flex fonsize-16 txt-tranf">
        <span class="nowrap"> <b>BÊN B:</b></span>
        <mark>
          <b>{{ customerInfo.merchantName }}</b>
        </mark>
      </p>

      <div class="form form-ext">
        <p>
          <span>Trụ sở: </span>
          <mark>
            {{ customerInfo.address }}
            <!-- {{ customerInfo.district }},
                {{ customerInfo.city }} -->
          </mark>
        </p>
        <p>
          Website:<mark v-if="customerInfo.website"> {{ customerInfo.website }}</mark>
        </p>
        <p>
          <span>Điện thoại:</span><mark>{{ customerInfo.mobile }}</mark>
          <span class="ml-4"> Fax: </span>
        </p>
        <p>
          Tài khoản:<mark> {{ customerInfo.accountNo }}</mark>
        </p>
        <p>
          Tại:<mark> {{ customerInfo.bankName }}</mark>
        </p>
        <p>
          <span>Mã số thuế:</span>
          <mark>
            {{ customerInfo.businessRegistrationNumber }}
          </mark>
        </p>
        <p>
          <span>Người đại diện: </span
          ><mark
            ><b>{{ customerInfo.customerName }}</b></mark
          >
          <span class="ml-4"
            >Chức vụ: <mark v-if="customerInfo.position"> {{ customerInfo.position }}</mark></span
          >
        </p>
      </div>

      <p>
        Sau đây, Bên A và Bên B gọi riêng là “Bên”, gọi chung là “Hai Bên” hoặc “Các Bên” tùy ngữ
        cảnh. Hai Bên cùng thỏa thuận hợp tác và cam kết thực hiện những điều sau đây:
      </p>

      <ol class="form-style1">
        <li>
          <h1>THÔNG TIN THIẾT BỊ</h1>
          <div>
            Để các dịch vụ đã được ký kết giữa Hai Bên trong Hợp đồng được thực hiện, ngoài các
            nghĩa vụ như đã ghi trong Hợp đồng, Bên A đồng ý cho Bên B mượn và Bên B đồng ý mượn của
            Bên A thiết bị (viết tắt là <b>“TB”</b>) đọc thẻ (Mobile Card Reader) có đặt cọc. Cụ thể
            như sau:
          </div>
          <!-- <div>Để các dịch vụ đã được ký kết giữa hai bên trong hợp đồng số <mark>{{ dataContract.code ? dataContract.code : '' }}</mark> ký ngày <mark>{{dataContract.effectiveFromDTO ? dataContract.effectiveFromDTO : dataContract.dateSign | formatDate}}</mark> được thực hiện, Ngoài các nghĩa vụ như đã ghi trong hợp đồng, bên A đồng ý cung cấp cho Bên B thiết bị (viết tắt là “TB”) đọc thẻ (Mobile Card Reader). Thiết bị này coi như là một cấu phần trong cơ sở hạ tầng bên A cung cấp cho bên B chạy dịch vụ. Cụ thể như sau:</div> -->
          <div><i>(Vui lòng chọn loại thiết bị theo nhu cầu tương ứng)</i></div>
          <div class="table-responsive">
            <table>
              <thead>
                <tr class="bg-head">
                  <th>Đánh dấu X</th>
                  <th>Tên thiết bị đầy đủ</th>
                  <th>Tên rút gọn</th>
                  <th>Tên viết tắt</th>
                  <th>Số lượng</th>
                </tr>
              </thead>
              <tbody>
                <tr class="text-center" v-for="(item, index) in deviceMposListContent" :key="index">
                  <td>{{ item.quantity ? 'X' : '' }}</td>
                  <td>{{ item.fullName }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.shortName }}</td>
                  <td>{{ item.quantity > 0 ? item.quantity : '' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </li>
        <li>
          <h1>QUY ĐỊNH CHUNG VỀ CUNG CẤP THIẾT BỊ</h1>
          <ol>
            <li>
              <span class="text-bold">Mức đặt cọc & giá bán thiết bị</span>
              <div class="table-responsive">
                <table>
                  <thead>
                    <tr class="bg-head">
                      <th class="text-center"><b>Loại thiết bị</b></th>
                      <th class="text-center"><b>Giá bán/ 01 thiết bị(VNĐ)</b></th>
                      <th class="text-center"><b>Mức đặt cọc/ 01 thiết bị(VNĐ)</b></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="text-center">
                      <td class="text-center">PR02</td>
                      <td class="text-center">1.500.000</td>
                      <td class="text-center">500.000</td>
                    </tr>
                    <tr class="text-center">
                      <td class="text-center">Mpos Pro</td>
                      <td class="text-center">1.900.000</td>
                      <td class="text-center">700.000</td>
                    </tr>
                    <tr class="text-center">
                      <td class="text-center">N31</td>
                      <td class="text-center">2.490.000</td>
                      <td class="text-center">700.000</td>
                    </tr>
                    <tr class="text-center">
                      <td class="text-center">Mini SmartPOS</td>
                      <td class="text-center">2.750.000</td>
                      <td class="text-center">1.000.000</td>
                    </tr>
                    <tr class="text-center">
                      <td class="text-center">N33</td>
                      <td class="text-center">3.500.000</td>
                      <td class="text-center">1.500.000</td>
                    </tr>
                    <tr class="text-center">
                      <td class="text-center">SmartPOS</td>
                      <td class="text-center">4.990.000</td>
                      <td class="text-center">2.000.000</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="text-bold">
                <b><i>Lưu ý:</i></b> Giá trên đã bao gồm VAT
              </div>
              <p>
                - Tương ứng với số lượng thiết bị Bên B đồng ý thuê của Bên A được nêu tại Điều 1 –
                Phụ lục này, tổng số tiền Bên B cần đặt cọc cho Bên A là:
                <mark
                  ><b>{{ appendixDeposit ? appendixDeposit : 0 | fomatCurrency }}</b></mark
                >
                <span
                  >(Bằng chữ:
                  <mark>
                    <b>
                      {{ dataAppendix ? appendixDeposit : 0 | formatPriceToText }} Việt Nam Đồng
                    </b> </mark
                  >).
                </span>
              </p>
            </li>
            <li>
              <span class="text-bold">Mức doanh số giao dịch tối thiểu</span>
              <p>
                2.2.1. Khi Bên B sử dụng thiết bị của Bên A, Bên B phải cam kết mức doanh số giao
                dịch tối thiểu/ 01 thiết bị/ tháng như sau:
              </p>
              <div class="table-responsive">
                <table>
                  <thead>
                    <tr class="bg-head">
                      <th class="text-center"><b>Loại thiết bị</b></th>
                      <th class="text-center">
                        <b>Doanh số giao dịch tối thiểu / 01 TB/ Tháng(VNĐ)</b>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="text-center">
                      <td class="text-center">PR02</td>
                      <td class="text-center">10.000.000</td>
                    </tr>
                    <tr class="text-center">
                      <td class="text-center">Mpos Pro</td>
                      <td class="text-center">20.000.000</td>
                    </tr>
                    <tr class="text-center">
                      <td class="text-center">N31</td>
                      <td class="text-center">20.000.000</td>
                    </tr>
                    <tr class="text-center">
                      <td class="text-center">Mini SmartPOS</td>
                      <td class="text-center">30.000.000</td>
                    </tr>
                    <tr class="text-center">
                      <td class="text-center">N33</td>
                      <td class="text-center">30.000.000</td>
                    </tr>
                    <tr class="text-center">
                      <td class="text-center">SmartPOS Pro</td>
                      <td class="text-center">50.000.000</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p>
                <span class="txt-bold">Lưu ý:</span> Chỉ ghi nhận loại giao dịch thanh toán thẻ,
                giao dịch MOTO (không bao gồm thanh toán qua link, giao dịch QR nội địa/quốc tế,
                giao dịch MOTO, giao dịch dịch vụ … )
              </p>
              <p>
                2.2.2. Trong vòng 02 (hai) tháng liên tiếp, nếu thiết bị mượn không đạt “Doanh số
                giao dịch thanh toán thẻ tối thiểu / 01 TB/ Tháng” đã cam kết hoặc Merchant không
                còn nhu cầu sử dụng, Merchant sẽ được chuyển sang cài đặt và sử dụng SoftPos miễn
                phí. Đồng thời, Bên A sẽ hoàn lại khoản tiền mà Bên B đã đặt cọc theo quy định tại
                Phụ lục này và thu hồi lại thiết bị.
              </p>
            </li>

            <li>
              <span class="text-bold">Thời hạn đối soát; thanh toán & xuất hóa đơn</span>
              <ul>
                <li>
                  Kỳ kinh doanh: Gọi T là tháng thiết bị được kích hoạt, kỳ kinh doanh được tính từ
                  ngày 25 tháng T-1 đến ngày 24 tháng T.
                </li>
                <li>
                  Thời gian bắt đầu tính doanh số giao dịch thanh toán thiết bị sẽ áp dụng tính từ
                  kỳ kinh doanh tiếp theo (T+1) kể từ ngày kích hoạt thiết bị mà Bên A cung cấp cho
                  Bên B. Ví dụ: Merchant kích hoạt mượn thiết bị từ ngày 15/9/2025, thì thời gian
                  bắt đầu tính doanh số giao dịch được áp dụng từ ngày 25/9/2025.
                </li>
                <li>
                  Trong vòng 05 (năm) ngày làm việc kể từ khi kết thúc kỳ T+1 tính doanh số giao
                  dịch thanh toán, Bên A gửi thông báo về doanh số giao dịch đã phát sinh của thiết
                  bị đã cung cấp cho Bên B kèm thông báo đạt/ không đạt điều kiện Mức doanh số giao
                  dịch tối thiểu và chi phí thiết bị tương ứng cần phải trả/ hoàn lại (nếu có) qua
                  hệ thống bên A hoặc email. Bên B kiểm tra và phản hồi lựa chọn tuân thủ theo đúng
                  quy định tại điểm 2.2 tại Hợp đồng đã cam kết đã ký trên hệ thống của Bên A.
                </li>
              </ul>
            </li>
            <li>
              <span class="text-bold">Tình trạng thiết bị:</span>
              <p>
                Bên A bảo đảm cung cấp hàng hoá đúng nhãn hiệu của hãng sản xuất theo như Điều 1 của
                Phụ lục này, đóng gói theo tiêu chuẩn nhà sản xuất.
              </p>
              <p>
                Sản phẩm được kiểm tra, cài đặt và đảm bảo hoạt động tốt với hệ thống thanh toán thẻ
                của Bên A trước khi bàn giao cho Bên B.
              </p>
            </li>
            <li>
              <span class="text-bold">Mục đích sử dụng:</span>
              <!-- <p>Bên A đồng ý cung cấp cho Bên B thiết bị là một cấu phần trong cơ sở hạ tầng mà Bên A cung cấp để triển khai dịch vụ thanh toán quẹt thẻ và thanh toán bằng QRCode theo thỏa thuận Hợp đồng hợp tác chấp nhận đơn vị thanh toán thẻ số: <mark>{{ dataContract.code ? dataContract.code : '' }}</mark>, đã ký kết giữa hai bên. </p> -->
              <p>
                Bên A đồng ý cho Bên B mượn thiết bị là một cấu phần trong cơ sở hạ tầng mà Bên A
                cung cấp để triển khai dịch vụ thanh toán quẹt thẻ và thanh toán bằng QRCode theo
                thỏa thuận tại Hợp đồng đã ký kết giữa Hai Bên.
              </p>
            </li>
            <li>
              <span class="text-bold">Thời gian và địa điểm bàn giao thiết bị</span>
              <ul>
                <li>
                  Tối đa 02 (hai) ngày làm việc kể từ ngày Phụ lục này được ký kết và Bên A nhận
                  được tiền thanh toán của Bên B, Bên A sẽ tiến hành giao thiết bị thanh toán thẻ
                  cho Bên B tại địa điểm do Bên B quy định.
                </li>
                <li>Phụ lục này là căn cứ để theo dõi bảo hành thiết bị, đổi hoặc trả thiết bị</li>
              </ul>
            </li>
            <li>
              <span class="text-bold">Hoàn trả thiết bị:</span>
              <ul style="list-style-type: none !important">
                <li>
                  - Trong vòng 02 (hai) tháng liên tiếp, thiết bị mượn không đạt “Doanh số giao dịch
                  thanh toán thẻ tối thiểu / 01 TB/ Tháng” đã cam kết thì Bên B hoàn trả thiết bị
                  cho Bên A.
                </li>
                <li>
                  - Khi hoàn trả thiết bị, Bên B phải đảm bảo các tiêu chí sau:
                  <p style="margin-left: 20px !important">
                    + Bên B hoàn trả thiết bị cho Bên A phải đảm bảo các thiết bị còn mới, không
                    hỏng hóc, không bị xước xát, không bị biến dạng.
                  </p>
                  <p style="margin-left: 20px !important">
                    + Trong trường hợp Bên B không hoàn trả đầy đủ lại sạc và hộp cho Bên A thì Bên
                    B phải đền bù cho Bên A khoản tiền: đối với sạc là: 200.000 (hai trăm nghìn)
                    VNĐ, hộp: 50.000 (năm mươi nghìn) VNĐ trong thời gian sử dụng từ 01 đến 06 tháng
                    kể từ ngày ký Phụ lục này, từ tháng thứ 7 trở đi thì Bên B sẽ không phải đền bù
                    khoản tiền sạc & hộp.
                  </p>
                  <p style="margin-left: 20px !important">
                    Riêng đối với Dock sạc N31 nếu Bên A làm thất lạc hoặc hỏng hóc thì bên A phải
                    đền bù cho bên B khoản tiền 300.000 (ba trăm nghìn đồng) VNĐ trong thời gian sử
                    dụng từ 01 đến 16 tháng kể từ ngày ký Phụ lục này, từ tháng thứ 17 trở đi thì
                    Bên B sẽ không phải đền bù khoản dock sạc này.
                  </p>
                  <p style="margin-left: 20px !important">
                    + Khi thiết bị hoàn trả phát sinh các vấn đề như: hỏng hóc do lỗi chủ quan khi
                    sử dụng của Bên B; xây xước và hư hại dễ thấy; bị mất; …, Bên B phải bồi thường
                    chi phí thiết bị cho Bên A theo <b>giá trị bồi thường thiết bị</b>.
                  </p>
                  <p style="margin-left: 20px !important">
                    + Thiết bị hỏng lỗi do Nhà sản xuất trong thời hạn bảo hành được Bên A xác nhận:
                    Bên B không phải bồi thường và được Bên A hoàn lại số tiền đã đặt cọc.
                  </p>
                  <p style="margin-left: 20px !important">+ Thiết bị do bên B làm mất thì:</p>
                  <div style="margin-left: 20px !important">
                    <ol>
                      <li>
                        Trường hợp thiết bị đã hết thời gian khấu hao và bên B đạt doanh số thanh
                        toán thẻ tối thiểu: bên A sẽ hoàn trả tiền cọc cho bên B, không yêu cầu thu
                        hồi xác máy.
                      </li>
                      <li>
                        Trường hợp thiết bị đã hết thời gian khấu hao và bên B không đạt doanh số
                        thanh toán thẻ tối thiểu: bên B phải bồi thường cho bên A phần giá trị khấu
                        hao thiết bị tính từ tháng bên B không đạt doanh số cho đến hết thời gian
                        khấu hao thiết bị
                      </li>
                      <li>
                        Trường hợp thiết bị còn thời gian khấu hao: Xử lý như trường hợp bên B làm
                        hỏng thiết bị, bên B phải bồi thường theo giá trị bồi thường thiết bị.
                      </li>
                    </ol>
                  </div>
                  <p style="margin-left: 20px !important">
                    + Để làm rõ điều kiện bồi thường trên, thì mức giá trị định giá cho thiết bị
                    (khi thiết bị hoàn trả phát sinh các vấn đề như: hỏng hóc do lỗi chủ quan khi sử
                    dụng; xây xước và hư hại dễ thấy; bị mất; …, ) được tính dựa trên thời gian khấu
                    hao và giá trị khấu hao thiết bị/ tháng.<br />
                    Trong đó, thời gian khấu hao thiết bị và giá trị khấu hao, được xác định:
                  </p>
                </li>
              </ul>
              <div class="table-responsive">
                <table>
                  <thead>
                    <tr class="bg-head">
                      <th class="text-center"><b>Loại thiết bị</b></th>
                      <th class="text-center"><b>Giá trị khấu hao thiết bị/tháng(VNĐ)</b></th>
                      <th class="text-center"><b>Thời gian khấu hao(Tháng)</b></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="text-center">
                      <td class="text-center"><b>PR02</b></td>
                      <td class="text-center">125.000</td>
                      <td class="text-center">12</td>
                    </tr>
                    <tr class="text-center">
                      <td class="text-center"><b>mPOS Pro</b></td>
                      <td class="text-center">165.000</td>
                      <td class="text-center">12</td>
                    </tr>
                    <tr class="text-center">
                      <td class="text-center"><b>N31</b></td>
                      <td class="text-center">150.000</td>
                      <td class="text-center">16</td>
                    </tr>
                    <tr class="text-center">
                      <td class="text-center"><b>Mini SmartPOS</b></td>
                      <td class="text-center">150.000</td>
                      <td class="text-center">18</td>
                    </tr>
                    <tr class="text-center">
                      <td class="text-center"><b>N33</b></td>
                      <td class="text-center">180.000</td>
                      <td class="text-center">20</td>
                    </tr>
                    <tr class="text-center">
                      <td class="text-center"><b>SmartPOS Pro</b></td>
                      <td class="text-center">220.000</td>
                      <td class="text-center">24</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p>Khi đó, giá trị bồi thường thiết bị:</p>
              <div class="text-center">
                <b
                  ><i
                    >Giá tiền thiết bị bồi thường = [Giá trị khấu hao thiết bị/tháng] x [(T.G khấu
                    hao) – (Thời gian đã sử dụng)]</i
                  ></b
                >
              </div>
              <!-- <p><i>Trong đó:</i></p>
                <div class="text-center">
                    <i>
                        (3) Thời gian khấu hao
                    </i>
                </div>
                <div class="text-center">
                    <i>
                        (4) Giá trị khấu hao/ tháng
                    </i>
                </div> -->
              <!-- <p>
                    - Trong trường hợp Bên B không hoàn trả đầy đủ lại sạc và hộp cho Bên A thì Bên B phải đền bù cho Bên A khoản tiền: đối với sạc là: 200.000 (hai trăm nghìn) VNĐ, hộp: 50.000 (năm mươi nghìn) VNĐ trong thời gian sử dụng từ 01 đến 06 tháng kể từ ngày ký phụ lục hợp đồng này, từ tháng thứ 7 trở đi thì bên B sẽ không phải đền bù khoản tiền sạc & hộp.
                </p> -->
              <p>
                <b><i>Ví dụ:</i></b
                >Bên B mượn thiết bị PR02 và đã đặt cọc 500.000 VNĐ cho bên A.
              </p>
              <p>
                Khi hoàn trả thiết bị, Bên B làm hỏng hóc do lỗi chủ quan khi sử dụng của bên B, giá
                trị bồi thường được tính như sau: TH1: Bên B đã sử dụng 4 tháng: Giá trị bồi thường
                = 125.000 x (12-4) = 1.000.000. Đã cọc 500.000. Số tiền bên B phải trả thêm bên A là
                500.000 VNĐ TH2: Bên B đã sử dụng trên 12 tháng: Giá trị bồi thường = 125.000 x
                (12-12) = 0. Đã cọc 500.000. Bên A hoàn lại cọc cho bên B là 500.000 VNĐ
              </p>
            </li>
            <li>
              <span class="text-bold">Lưu ý chung</span>
              <ul>
                <li>
                  <b>KHÔNG</b> hỗ trợ thanh lý, chuyển nhượng thiết bị Bên A cung cấp cho Bên B theo
                  Phụ lục này.
                </li>
                <!-- <li>
                    Quy ước chung về thời gian bắt đầu cung cấp thiết bị theo phụ lục này:
                    <ol>
                      <li>Kỳ kinh doanh: Gọi T là tháng đối soát, kỳ kinh doanh được tính từ ngày 25 tháng T-1 đến ngày 24 tháng T.</li>
                      <li>Thời gian bắt đầu áp dụng Chính sách cung cấp thiết bị theo Phụ lục này: Tính từ kỳ kinh doanh tháng T+1 kể từ ngày kích hoạt thiết bị Bên A cung cấp cho Bên B theo Phụ lục này.</li>
                    </ol>
                  </li>
                  <li><b>KHÔNG</b> hỗ trợ thanh lý, chuyển nhượng thiết bị Bên A cung cấp cho Bên B theo Phụ lục này.</li>
                  <li>Tất cả các Biên bản thu hồi, bàn giao liên quan thiết bị Bên A cung cấp cho Bên B theo Phụ lục này đều phải triển khai và quản lý trên hệ thống My NextPay.<br/> <br/>
                  <i>Ví dụ: Bên B kích hoạt thiết bị được cung cấp bởi Bên A theo Phụ lục này từ ngày 15/5/2025, thì thời gian bắt đầu áp dụng chính sách từ ngày 25/5/2025.</i>
                  </li> -->
              </ul>
            </li>
          </ol>
        </li>
        <li>
          <h1>QUY ĐỊNH VỀ THU HỒI VÀ KHOÁ THIẾT BỊ TRÊN HỆ THỐNG</h1>
          <p>Bên A giữ quyền khóa thiết bị trên hệ thống trong các trường hợp sau:</p>
          <ul>
            <li>Bên B vi phạm các điều khoản trong Hợp đồng cung cấp dịch vụ đã ký với Bên A.</li>
            <li>
              Bên B có thông báo cho Bên A bằng văn bản hoặc email về việc yêu cầu ngưng sử dụng.
            </li>
          </ul>
        </li>
        <!-- <li>
            <h1>CHUYỂN QUYỀN SỞ HỮU THIẾT BỊ</h1>
            <p>Nếu Bên B đạt tổng doanh số giao dịch tích lũy theo các mức được quy định dưới đây, Bên A sẽ hoàn 100% tiền đặt cọc & chuyển quyền sở hữu thiết bị cho Bên B:</p>
            <div class="table-responsive">
                <table>
                    <thead>
                        <tr class="bg-head">
                            <th class="text-center"><b>Loại thiết bị</b></th>
                            <th class="text-center"><b>Doanh số tích luỹ / (kể từ thời điểm kích hoạt) / 01 TB
                                    (VNĐ)
                                </b></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="text-center">
                            <td class="text-center">TingboxS1, Tingbox01, Tingbox02</td>
                            <td class="text-center">1.000.000.000</td>
                        </tr>
                         <tr class="text-center">
                            <td class="text-center">PR02</td>
                            <td class="text-center">1.500.000.000</td>
                        </tr>
                          <tr class="text-center">
                            <td class="text-center">mPOS Pro</td>
                            <td class="text-center">2.000.000.000</td>
                        </tr>
                        <tr class="text-center">
                            <td class="text-center">N31</td>
                            <td class="text-center">2.500.000.000</td>
                        </tr>
                        <tr class="text-center">
                            <td class="text-center">Mini SmartPOS</td>
                            <td class="text-center">2.800.000.000</td>
                        </tr>
                        <tr class="text-center">
                            <td class="text-center">N33</td>
                            <td class="text-center">3.500.000.000</td>
                        </tr>
                        <tr class="text-center">
                            <td class="text-center">SmartPOS Pro</td>
                            <td class="text-center">5.000.000.000</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </li> -->
        <li>
          <h1>THÔNG TIN THIẾT BỊ BÀN GIAO</h1>
          <p>
            Số lượng thiết bị bàn giao:
            <mark>{{ numberDeviceLend }}</mark>
            (chiếc). Thông tin chi tiết như sau:
          </p>
          <div class="table-responsive">
            <table>
              <thead>
                <tr class="bg-head">
                  <th style="width: 100px"><b>TT</b></th>
                  <th>
                    <b>Tên Điểm<br />Chấp Nhận</b>
                  </th>
                  <th><b>SĐT liên hệ</b></th>
                  <th><b>Địa chỉ</b></th>
                  <th><b>Loại tiền tệ</b></th>
                  <th><b>Serial thiết bị</b></th>
                  <th><b>Số điện thoại </b></th>
                  <th><b>Email tài khoản </b></th>
                </tr>
              </thead>
              <tbody v-for="(item, index) in appendixLendOrDevice" :key="index">
                <tr class="txt-center">
                  <td class="txt-center">{{ index + 1 }}</td>
                  <td class="txt-center">{{ merchantBusinessAreasDevice[index].areaName }}</td>
                  <td class="txt-center">{{ customerInfo.authoriserContactNumber }}</td>
                  <td class="txt-center">{{ merchantBusinessAreasDevice[index].areaAddress }}</td>
                  <td>VNĐ</td>
                  <td>{{ item.serialNumber }}</td>
                  <td>{{ customerInfo.mobile }}</td>
                  <td>{{ customerInfo.email }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </li>
        <li>
          <h1>TÌNH TRẠNG THIẾT BỊ BÀN GIAO</h1>
          <p>
            Tất cả các thiết bị bàn giao đã được Hai Bên kiểm tra và xác nhận là sản phẩm hoạt động
            bình thường, đúng chủng loại, nhãn hiệu của Nhà sản xuất và được đóng gói nguyên vẹn
            theo tiêu chuẩn của Nhà sản xuất.
          </p>
        </li>
        <li>
          <h1>NỘI DUNG BÀN GIAO VÀ NGHIỆM THU KHÁC</h1>
          <div class="table-responsive">
            <table>
              <thead>
                <tr class="bg-head">
                  <th><b>STT</b></th>
                  <th><b>NHÓM DỊCH VỤ</b></th>
                  <th><b>NỘI DUNG HƯỚNG DẪN/ BÀN GIAO</b></th>
                  <th><b>XÁC NHẬN </b></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="txt-center"><b>1</b></td>
                  <td><b>Khởi động thiết bị</b></td>
                  <td>Thao tác bật/ tắt và sạc pin cho thiết bị mới</td>
                  <td rowspan="2">
                    <span style="font-size: 30px; color: #0085ff"><i class="bx bx-check"></i></span>
                  </td>
                </tr>
                <tr>
                  <td class="txt-center"><b>2</b></td>
                  <td rowspan="2">
                    <b>Thanh toán thẻ</b>
                  </td>
                  <td>Nhận diện Thẻ chíp/Thẻ từ/Thẻ Contactless; ATM/Debit/Credit</td>
                  <!-- <td>
                    <span style="font-size: 30px; color: #0085ff"
                      ><i class="bx bx-check"></i
                    ></span>
                  </td> -->
                </tr>
                <tr>
                  <td class="txt-center"><b>3</b></td>
                  <td>
                    Quẹt với thẻ từ / Cắm với thẻ chíp/ Chạm với thẻ Contactless/ In hoá đơn với
                    SmartPOS (nếu có giấy)
                  </td>
                  <td>
                    <span style="font-size: 30px; color: #0085ff"><i class="bx bx-check"></i></span>
                  </td>
                </tr>

                <tr class="bg-head">
                  <td colspan="4">
                    <b>Thanh toán thông thường/ Trả Góp 0%</b>
                  </td>
                </tr>
                <tr>
                  <td class="txt-center"><b>1</b></td>
                  <td rowspan="2"><b>Thao tác sử dụng</b></td>
                  <td>Lựa chọn đúng mục thanh toán thường/ trả góp</td>
                  <td>
                    <span style="font-size: 30px; color: #0085ff"><i class="bx bx-check"></i></span>
                  </td>
                </tr>
                <tr>
                  <td class="txt-center"><b>2</b></td>
                  <td>Lựa chọn ngân hàng và kỳ hạn</td>
                  <td>
                    <span style="font-size: 30px; color: #0085ff"><i class="bx bx-check"></i></span>
                  </td>
                </tr>
                <tr>
                  <td class="txt-center"><b>3</b></td>
                  <td rowspan="3"><b>Quy trình hoàn thiện</b></td>
                  <td>Nhập thông tin hóa đơn và khách hàng (chủ thẻ)</td>
                  <td>
                    <span style="font-size: 30px; color: #0085ff"><i class="bx bx-check"></i></span>
                  </td>
                </tr>
                <tr>
                  <td class="txt-center"><b>4</b></td>
                  <td>Theo từng quy trình của từng NH</td>
                  <td>
                    <span style="font-size: 30px; color: #0085ff"><i class="bx bx-check"></i></span>
                  </td>
                </tr>
                <tr>
                  <td class="txt-center"><b>5</b></td>
                  <td>Các lưu ý "Maritimebank, Techcombank …"</td>
                  <td>
                    <span style="font-size: 30px; color: #0085ff"><i class="bx bx-check"></i></span>
                  </td>
                </tr>
                <tr>
                  <td class="txt-center"><b>6</b></td>
                  <td><b>Tài liệu hướng dẫn</b></td>
                  <td>Thông tin liên hệ các bộ phận Vận hành, Kỹ thuật</td>
                  <td>
                    <span style="font-size: 30px; color: #0085ff"><i class="bx bx-check"></i></span>
                  </td>
                </tr>
                <tr>
                  <td class="txt-center"><b>7</b></td>
                  <td><b>Các khoản phí</b></td>
                  <td>Phí trả góp, phí quẹt thẻ</td>
                  <td>
                    <span style="font-size: 30px; color: #0085ff"><i class="bx bx-check"></i></span>
                  </td>
                </tr>

                <tr class="bg-head">
                  <td colspan="4">
                    <b>Kiểm tra lịch sử giao dịch / Kết toán</b>
                  </td>
                </tr>
                <tr>
                  <td class="txt-center"><b>1</b></td>
                  <td rowspan="5"><b>Xác nhận giao dịch</b></td>
                  <td>Lịch sử giao dịch trong ngày/ trước đó</td>
                  <td>
                    <span style="font-size: 30px; color: #0085ff"><i class="bx bx-check"></i></span>
                  </td>
                </tr>
                <tr>
                  <td class="txt-center"><b>2</b></td>
                  <td>Kết toán giao dịch</td>
                  <td>
                    <span style="font-size: 30px; color: #0085ff"><i class="bx bx-check"></i></span>
                  </td>
                </tr>

                <tr>
                  <td class="txt-center"><b>3</b></td>
                  <td>Huỷ giao dịch/ Hoàn tiền giao dịch</td>
                  <td>
                    <span style="font-size: 30px; color: #0085ff"><i class="bx bx-check"></i></span>
                  </td>
                </tr>
                <tr>
                  <td class="txt-center"><b>4</b></td>
                  <td>Gửi lại hoá đơn qua email</td>
                  <td rowspan="2">
                    <span style="font-size: 30px; color: #0085ff"><i class="bx bx-check"></i></span>
                  </td>
                </tr>
                <tr>
                  <td class="txt-center"><b>5</b></td>
                  <td>Đăng nhập bằng email của Merchant trên hệ thống của bên A</td>
                </tr>
              </tbody>
            </table>
          </div>
        </li>
        <li>
          <h1>ĐIỀU KHOẢN THI HÀNH</h1>
          <ul class="form-style2">
            <li>
              Phụ lục này là bộ phận không thể tách rời của Hợp đồng và các điều khoản khác của Hợp
              đồng vẫn được giữ nguyên. Các bên cam kết tuân thủ các quy định trong phụ lục Hợp đồng
              này.
            </li>
            <li>
              Phụ lục này có hiệu lực kể từ ngày đại diện có thẩm quyền của hai Bên tham gia ký kết.
              Thời hạn hiệu lực của Phụ lục này được xác định theo thời hạn hiệu lực của Hợp đồng
              nêu trên trừ khi hai bên có thỏa thuận khác bằng văn bản.
            </li>
            <li>
              Phụ lục này được lập thành 02 (hai) bản có nội dung và giá trị pháp lý như nhau, mỗi
              Bên giữ 01 (một) bản.
            </li>
          </ul>
        </li>
      </ol>
      <Footer
        v-if="!checkCreatedDateNganluong(dataAppendix)"
        :dataContract="dataContract"
        :dataAppendix="dataAppendix"
        :isAppendix="true"
      ></Footer>
      <FooterNL
        v-else
        :dataContract="dataContract"
        :dataAppendix="dataAppendix"
        :isAppendix="true"
      ></FooterNL>
    </div>
  </div>
</template>

<script>
  import Header from '../block/header.vue'
  import Footer from '../block/footer.vue'
  import HeaderNL from '../block/headerNL.vue'
  import FooterNL from '../block/footerNL.vue'
  export default {
    props: ['dataContract', 'appendix'],
    components: {
      Header,
      Footer,
      HeaderNL,
      FooterNL,
    },
    data() {
      return {
        deviceMposListHead: [],
        deviceMposListContent: [],
      }
    },
    computed: {
      customerInfo() {
        return this.dataContract.customerInfoRes ?? this.dataContract.customerInfoCommon ?? {}
      },
      dataAppendix() {
        return this.appendix ?? this.dataContract.lstAppendixDevices
      },

      appendixLendOrDevice() {
        const appendix = this.dataAppendix
        const devices = appendix.appendixLend ?? appendix[appendix.length - 1].appendixDevice

        return devices?.deviceInfos ?? []
      },
      merchantBusinessAreasDevice() {
        return this.appendixLendOrDevice.map(s => {
          return (
            (this.dataAppendix.merchantBusinessAreas
              ? this.dataAppendix.merchantBusinessAreas
              : this.dataAppendix[this.dataAppendix.length - 1].merchantBusinessAreas
            ).find(z => z.serials.includes(s.serialNumber)) ?? {}
          )
        })
      },
      appendixDeposit() {
        const appendix = this.dataAppendix
        const devices = appendix.appendixLend ?? appendix[appendix.length - 1].appendixDevice
        return devices?.deposit ?? []
      },
      codeAppendixLend() {
        const appendix = this.dataAppendix
        const devices = appendix.appendixLend ?? appendix[appendix.length - 1].appendixDevice
        return this.dataAppendix.code ? this.dataAppendix.code : devices.codeAppend || ''
      },
      numberDeviceLend() {
        return this.dataAppendix.numDevices
          ? this.dataAppendix.numDevices
          : this.dataContract.lstAppendixDevices[this.dataContract.lstAppendixDevices.length - 1]
              .numDevices || 0
      },
    },
    mounted() {
      this.deviceMposListHead = this.dataContract.deviceMposList
        ? this.dataContract.deviceMposList.filter((e, i) => i === 0)
        : []
      this.deviceMposListContent = this.dataContract.deviceMposList
        ? this.dataContract.deviceMposList.filter((e, i) => i !== 0)
        : []
      this.deviceMposListContent.forEach(_device => {
        _device.quantity = 0
      })
      const appendix = this.dataAppendix
      const devices =
        appendix.appendixLend?.deviceInfos ??
        appendix[appendix.length - 1].appendixDevice.deviceInfos
      if (devices.length > 0) {
        if (this.deviceMposListContent.length > 0) {
          devices.forEach(device => {
            this.deviceMposListContent.forEach(_device => {
              if (device.name === _device.shortName) {
                if (_device.quantity !== undefined) {
                  _device.quantity += device.quantity
                } else {
                  _device.quantity = device.quantity
                }
              }
            })
          })
        }
      }
    },
  }
</script>

<style scoped src="@/assets/css/style-review.css"></style>
